export const initialState = {
    blog: {
        records: 0,
        posts: undefined,
    },
    post: undefined,
    loading: false,
    saving: false,
    error: false,
};
